<template>
<div>
    <form @reset="onReset" class="item-editor-form">
   
        <fg-input v-model="form.uniqueId" :label="$t('infopoints.id')" :disabled="disabled || action == 'edit'"></fg-input>
        <fg-input v-model="form.name" :label="$t('infopoints.name')" :disabled="disabled"></fg-input>
         
        <div class='infopoint-editor-groups'>
        <label>{{ $t('infopoints.groups') }}</label>
        <b-row>
            <b-col>
                <div v-if="form.device.groups && form.device.groups.length > 0">
                    <div v-for="group in form.device.groups" :key="group.id">
                        <!--b-badge href="#" @click='unselectGroup(group.id)'>{{ group.name }}<span class='x'>x</span></b-badge>-->
                        <t-badge clickable @click='unselectGroup(group.id)' :background="getGroupColor(group.id)">{{ group.name }}<span class='x'>x</span></t-badge>
                    </div>
                </div>
                <div v-else>-</div>

            </b-col>
            <b-col style='text-align: right'>
                <SelectList v-if='showGroupSelect' :options="groupOptions" @select="selectGroup" :searchable="true" :clearable="true" :value="0" :disabled="disabled" />
                <t-button v-else type="add-icon" @click="showGroupSelect = true" :disabled="loading" :title="$t('button.add')"></t-button> 
            </b-col>
        </b-row>
        </div>


        <b-row>
            <b-col><fg-input v-model="form.device.location.latitude" :label="$t('infopoints.lat')" :disabled="disabled"></fg-input></b-col>
            <b-col><fg-input v-model="form.device.location.longitude" :label="$t('infopoints.lon')" :disabled="disabled"></fg-input></b-col>
        </b-row>
        <fg-input v-model="deviceVolume" :label="'Volume'" :disabled="loading"></fg-input>
        
        <SelectList :label="$t('infopoints.mode')" :options="modeOptions" :value="form.device.mode" @select="selectMode" :searchable="false" :clearable="false" :disabled="disabled"/>



        <div v-if="action == 'edit'">
            <div v-for="odParameter in organizationDeviceParameters" :key="odParameter.id">
                <!-- Screenshot schedule is the first device parameter to be added to this Infopoint editor UI.
                An example for making a more generic UI for device parameters can be found in /components/Devices/SseDisplays/SseDisplayEditor.vue -->
                <div v-if="odParameter.name === 'screenshot_schedule'">
                    <fg-input :label="$t(odParameter.descriptionId)" v-model="itemDeviceParameters[odParameter.name]" />
                </div>
            </div>
        </div>

        <!--
        <FormButtons
            @submit="onSubmit" 
            :reset="false" 
            :remove="action == 'edit'" 
            @remove="remove"
            :disableSubmit="!inputChanged || loading"
            :disableRemove="disabled || loading "/>
        -->
        <t-button-group>
            <t-button type="save" @click="save" :disabled="disabled"></t-button> 
            <t-button v-if="action == 'edit'" type="rm" @click="remove" :disabled="disabled" right></t-button> 
        </t-button-group>

        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />

    </form>
    <DeleteModal :itemid="selectedInfopoint ? selectedInfopoint.uniqueId : ''" @ok="onDeleteOK" />
</div>
</template>

<script>
import infopoint from '@/store/displays/infopoint'
import device from '@/store/displays/device'
import deviceGroup from '@/store/displays/deviceGroup'

export default {
    name: 'InfopointEditForm',
    props: {
        item: { default: null },
        action: { default: "new" }
    },
    data: function() {
        return  {
            disabled: false,
            "deviceVolume": "",
            defaultFormData: {
                'uniqueId': null,
                'name': null,
                'mediaGroupId': null,
                'type': null,
                "device" : {
                    "deviceId": null,
                    "location": {
                        "latitude" : null, 
                        "longitude" : null
                    },
                    "attributes": [],
                } 
            },
            form: {
                'uniqueId': null,
                'name': null,
                'mediaGroupId': null,
                'type': null,
                "device" : {
                    "deviceId": null,
                    "location": {
                        "latitude" : null, 
                        "longitude" : null
                    },
                    "mode": null,
                    "attributes": []
                } 
            },
            ok: false,
            error: false,
            loading: false,
            infoType: "save",
            modeOptions: [
                { id: 'IN_OPERATION', label: this.$t('infopoints.modes.IN_OPERATION'), icon: 'check-square', variant: 'success' },
                { id: 'IN_REPAIR', label: this.$t('infopoints.modes.IN_REPAIR'), icon: 'tools' },
                { id: 'IN_STORAGE', label: this.$t('infopoints.modes.IN_STORAGE'), icon: 'inboxes' },
                { id: 'NOT_WORKING', label: this.$t('infopoints.modes.NOT_WORKING'), icon: 'x-circle' },
                { id: 'NOT_TRACKED', label: this.$t('infopoints.modes.NOT_TRACKED'), icon: 'eye-slash' }
            ],
            itemDeviceParameters: {},
            showGroupSelect: false 
           
        }
    },
    computed: {
        mediaGroupOptions: function() {
            var optionList = [];
            for (var mediaGroup of this.$store.state.infopoint.mediaGroupList) {
                optionList.push({ id: mediaGroup.id, name: mediaGroup.name })
            }
            return optionList;
        },
        typeOptions: function() {
            var optionList = [];
            for (var type of this.$store.state.infopoint.infopointTypeList) {
                optionList.push({ id: type, name: type });
            }
            return optionList;
        },
        resetDisabled() {
            return this.form.uniqueId == null;
        },
        storeVolume () {
            return this.$store.getters['infopoint/deviceVolume'];
        },
        selectedInfopoint() {
            return this.item;
        },
        infopointLabel() {
            return this.form.uniqueId; 
        },
        inputChanged(){
            if(this.selectedInfopoint){
                var deviceChanged = true;
                if(this.selectedInfopoint.device){
                    deviceChanged = (this.form.device.location.latitude != this.selectedInfopoint.device.location.latitude)
                                  || (this.form.device.location.longitude != this.selectedInfopoint.device.location.longitude) 
                                  || (this.deviceVolume != this.selectedInfopoint.deviceVolume) 
                                  || (this.form.device.mode != this.selectedInfopoint.device.mode) ;

                    if (!deviceChanged) {
                        const oldParams = this.makeDeviceParameterObject(this.selectedInfopoint.device.attributes);
                        for (const [key, value] of Object.entries(this.itemDeviceParameters)) {
                            if (oldParams[key] != value) {
                                deviceChanged = true;
                                break;
                            }
                        }
                    }
                }
               
                return  deviceChanged
                        || (this.form.uniqueId != this.selectedInfopoint.uniqueId) 
                        || (this.form.name != this.selectedInfopoint.name) 
            }
            return true;
        },
        organizationDeviceParameters() {
            return this.$store.state.device.organizationDeviceParameters.list;
        },
        groupOptions(){
            var optionList = [];

            optionList.push( { id: 0, label: this.$t('infopoints.groups_add'), icon: 'plus', caption: this.$t('infopoints.groups_add') } ); 

            for (var item of this.$store.state.deviceGroup.deviceGroupList) {
                 optionList.push( { id: item.id, label: item.name } );
            }
        
            return optionList;
        }
    },
    watch: {
        item: {
            handler(newVal) {
                if (!newVal) {
                    return;
                }
                this.ok = this.error = this.loading = this.disabled = false;
                this.copyItemData();
                this.loadConfigData(newVal.uniqueId);
                this.itemDeviceParameters = this.makeDeviceParameterObject(this.form.device.attributes);
            },
            immediate: true  
        },
        action: {
            handler(newVal) {
                if (newVal == 'new') {
                    this.$store.commit('infopoint/updateInfopointVolume', '');
                    this.$store.commit('infopoint/setInfopointConfiguration', []);
                }
            },
            immediate: true  
        },
        storeVolume:  {
            handler(newVal) {
                this.deviceVolume = newVal;
            },
            immediate: true  
        },
    },
    methods: {
        async loadConfigData(label) {
            this.loading = this.disabled = true;
            try {
                const response = await this.$store.dispatch('infopoint/loadConfiguration', label);
                if(response.status != 200) {
                    console.error('Error getting infopoint volume')
                }
                this.loading = false;
                this.disabled = false;
            } catch (error) {
                console.error("Error loading config:", error);
            } finally {
                this.loading = this.disabled = false;
            }
        },
        newInfopoint() {
            this.form = Object.assign({}, this.defaultFormData);
            this.disabled = false;
        },
        setDeviceVolume(volume) {
            let payload = {
                    infopointLabel: this.infopointLabel,
                    volume: volume
                };
            this.$store.dispatch('infopoint/updateVolume', payload);
            this.deviceVolume = volume; 
        },
        
        save(event) {
            if(event) event.preventDefault();
            this.form.device.configuration = this.makeDeviceParameterArray();
            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = this.disabled = true;
            let volume = this.deviceVolume;

            this.$store.dispatch('infopoint/saveInfopoint', this.form).then(response => {
                setTimeout(() => { 
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                    this.loading = this.disabled = false;
                    this.setDeviceVolume(volume);
                    // this.$emit('itemSaved', this.form);
                }, 1000);
             })
            .catch( () => { this.error = true; }) 
            .finally( ); 
        },
        onReset(event) {
            event.preventDefault();
            this.$store.commit('infopoint/changeSelectedInfopoint', null);
            this.form = this.defaultFormData;
            this.disabled = true;
        },
        remove(){
            this.$bvModal.show('delete-modal')
        },
        onDeleteOK() {
            this.infoType = "delete";
            this.loading = this.disabled = true;
            this.$store.dispatch('infopoint/deleteInfopoint', this.selectedInfopoint.id).then(response => {
                setTimeout(() => { 
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                    this.loading = false;
                }, 1000);
            }, () => {
                
            });
           
        },
        copyItemData() {
            if (this.item) {
                this.form = JSON.parse(JSON.stringify(this.item))
                if (!this.form.device) {
                    this.form.device =  {
                        "deviceId": null,
                        "location": {
                            "latitude" : null,
                            "longitude" : null
                        },
                        "attributes": []
                    }
                }
            }
        },
        selectMode(value){
            this.form.device.mode = value;
        },
        makeDeviceParameterObject: function(pArray) {
            if (!pArray)
                return;
            let paramObj = {};
            pArray.forEach(i => {
                if (i.value.toLowerCase() === 'true' || i.value.toLowerCase() === 'false') {
                    paramObj[i.name] = i.value.toLowerCase() === 'true';
                } else {
                    paramObj[i.name] = i.value
                }
            });
            return paramObj;
        },
        makeDeviceParameterArray: function() {
            let rArray = [];
            for (let [key, value] of Object.entries(this.itemDeviceParameters)) {
                let entryValue = value;
                if (typeof(value) === 'object' && value != null) {
                    entryValue = value.value;
                }
                let entry = {};
                entry.name = key
                entry.value = ''+ entryValue;
                rArray.push(entry);
            }
            return rArray;
        },

        selectGroup(id){
            if(id){
                if(!this.form.device.groups) this.form.device.groups = [];

                let selectedGroup = this.$store.state.deviceGroup.deviceGroupList.find(group => group.id == id);
                let exists = this.form.device.groups.some(group => group.id == id);

                if(selectedGroup && !exists){
                    this.form.device.groups.push( { id: selectedGroup.id, name: selectedGroup.name } );
                
                    // this.form.device.groups.push(selectedGroup);
                }
               
            }
        },
        unselectGroup(id){
            this.form.device.groups = this.form.device.groups.filter(group => group.id != id);
        },
        getGroupColor(id){
            let group = this.$store.state.deviceGroup.deviceGroupList.find(group => group.id == id);
            let color = group ? group.color : ""
            return color;
        }
    },



    beforeCreate: function() {
        if (!this.$store.state.infopoint) {
             this.$store.registerModule("infopoint", infopoint);
        }
        
        if (!this.$store.state.device) {
             this.$store.registerModule("device", device);
        }

        if (!this.$store.state.deviceGroup) {
            this.$store.registerModule('deviceGroup', deviceGroup)
        }

        this.$store.dispatch('infopoint/getMediaGroupList');
        this.$store.dispatch('infopoint/getInfopointTypeList');
        this.$store.dispatch('deviceGroup/getDeviceGroupList')
    },
    created() {
        this.copyItemData();
        this.itemDeviceParameters = this.makeDeviceParameterObject(this.form.device.attributes);

        if (this.$store.state.device && this.item?.organisaatio) {
            this.$store.dispatch('device/getOrganizationDeviceParameters', this.item.organisaatio)
        }
    }

}
</script>

<style lang="scss">
    @import 'vue-select/src/scss/vue-select.scss';
</style>